/* eslint-disable  */

import React, { useMemo, useState } from 'react';
import Dayjs from 'dayjs';
import {
    Typography, Button, Dialog, DialogContent, Grid, 
    IconButton, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@mui/x-data-grid';
import Form from './Form';
import Swal from '#/swal';
import {
    useCreateEmployee, useDeleteEmployee, useEmployees, useUpdateEmployee
} from '~/employees';
import { checkPermissions } from '#/permissions';
import { roles } from '#/constants';
import { getState } from '../../store';



const useStyles = makeStyles({
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
        }
    },
    tableWrapper: {
        width: '100%'
    },
    redButton: {
        color: '#fff',
        backgroundColor: '#DB2828'
    }
});


const ListEmployees = props => {

    const { history } = props;

    const classes = useStyles();
    const { data: employees, isLoading } = useEmployees();
    const { mutate: deleteEmployee } = useDeleteEmployee();
    const { mutate: updateEmployee } = useUpdateEmployee();
    const { mutate: createEmployee } = useCreateEmployee();

    const [initialValues, setInitialValues] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [actions, setActions] = useState(null);
    const [rowSelected, setRowSelected]=useState();

    const { role } = getState().auth;
    const isAdmin = checkPermissions([roles.admin], role);
    
    // Delete employee handle
        const handleDelete = async rowSelected => {
            const { value } = await Swal.fire.warning({ text: `Are you sure you want to delete ${rowSelected.name}` });

            if (value) {
                deleteEmployee(rowSelected.id);
            }
        };

    //Submit
           
        const onSubmit = values => {
            if (initialValues) {
                updateEmployee({
                    id: values.id,
                    payload: values
                });
            }
                else {
                    createEmployee(values);
                }
                setModalOpen(false);
            };


    // Popover settings.

        const openPopover = (event, row) => {

            // console.log("????", row)
            setRowSelected(row)
            setActions(event.currentTarget);
        };

        const closePopover = () => {
            setActions(null);
        };
        const moreActions = Boolean(actions);


    const columns = useMemo(() => [
        {
            field: 'name',
            renderHeader: () => <strong>Name</strong>,
            flex: 1
        },
        {
            field: 'title',
            renderHeader: () => <strong>Title</strong>,
            valueGetter: ({ row }) => row.title.name,
            flex: 1
        },
        {
            field: 'departments',
            renderHeader: () => <strong>Departments</strong>,
            valueGetter: ({ row }) => row.departments[0]?.name,
            renderCell: ({ row }) => row.departments.map(dept => dept.name).join(', '),
            flex: 1
        },
        {
            field: 'hire_date',
            renderHeader: () => <strong>Hire Date</strong>,
            renderCell: ({ row }) => {
                return Dayjs(row.hire_date).format("MM/DD/YYYY")
            },
            type: 'date',
            flex: 1
        },
        {
            field: 'id',
            align: 'right',
            headerAlign: 'right',
            renderHeader: () => <strong>Actions</strong>,
            renderCell: ({ row }) => (
                <div>
                    <IconButton
                        onClick= {(e) => openPopover(e, row)}> 
                        <MoreVert />
                    </IconButton>
                </div>

            ),
            flex: 1
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ], []);

    return (
        <div>
            <Grid container justifyContent='space-between' style={{ marginBottom: '20px', marginTop: '20px' }}>

                <Grid item>
                    <Typography variant='h4' children='Employees' />
                </Grid>

                <Grid item>
                    <Button
                        children='New Employee'
                        variant='contained'
                        color='primary'
                        onClick={() => {
                            setInitialValues(null);
                            setModalOpen(true);
                        }}
                    />

                </Grid>

            </Grid>

            <div className={classes.tableWrapper}>

                <DataGrid
                    className={classes.dataGrid}
                    loading={isLoading}
                    columns={columns}
                    rows={employees || []}
                    autoHeight
                    disableSelectionOnClick
                    hideFooterSelectedRowCount
                />

                 <div>
                    <Menu
                        id='actions'
                        open={moreActions}
                        anchorEl={actions}
                        onClose={closePopover} 
                        onClickCapture={closePopover}
                    >
                        <MenuItem 
                            onClick={() => {
                                setInitialValues(rowSelected);
                                setModalOpen(true);
                            }}>
                            Edit
                        </MenuItem>
                        {isAdmin && <MenuItem 
                        onClick={ () => handleDelete(rowSelected) }>
                            Delete
                        </MenuItem>}
                        <MenuItem 
                        onClick={() => history.push(`/employees/${rowSelected.id}/evals`)}>
                            View Evaluations
                        </MenuItem>
                    </Menu>
                </div>

            </div>

            <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
                <DialogContent>
                    <Form setModalOpen={setModalOpen} initialValues={initialValues} onSubmit={onSubmit}/>
                </DialogContent>
            </Dialog>

        </div>
    );
};


export default ListEmployees;

